interface ClinicConditionEditorState {
  editedConditionId: string | null;
}

export interface State {
  conditionEditor: ClinicConditionEditorState;
}

export enum ActionTypes {
  SET_EDITED_CONDITION_ID = 'questionnaire/SET_EDITED_CONDITION_ID'
}
